import React from 'react';
import { useTranslation } from 'react-i18next';
import { Props as ButtonProps } from '@hvcgroep/design-system/dist/components/Button';

import Button from '../../../../shared/components/Button';
import './style.scss';

interface Props {
  onGoBack?: () => void;
  submitButtonType?: ButtonProps['type']
  submitButtonIsLoading?: ButtonProps['isLoading']
  submitButtonChildren?: string
}

const JourneyActionButtons = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const {
    onGoBack,
    submitButtonType,
    submitButtonIsLoading,
    submitButtonChildren,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="JourneyActionButtons">
      {onGoBack && (
        <Button type="secondary" onClick={onGoBack} variation="center" className="JourneyActionButtons__GoBackButton--desktop">
          {t('journey.back')}
        </Button>
      )}
      {onGoBack && (
      <Button type="text" onClick={onGoBack} variation="center" className="JourneyActionButtons__GoBackButton--mobile">
        {t('journey.back')}
      </Button>
      )}
      <Button
        htmlType="submit"
        ref={ref}
        type={submitButtonType || 'secondary'}
        isLoading={submitButtonIsLoading}
        variation="center"
      >
        {submitButtonChildren || t('journey.next')}
      </Button>
    </div>
  );
});

export default JourneyActionButtons;
